import styles from './index.module.less';
import CookieConsent from 'react-cookie-consent';
import Cookies from 'js-cookie';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { setConsent } from 'firebase/analytics';
import { clarity } from 'react-microsoft-clarity';

// 清理分析工具相关的 cookies
export const clearAnalyticsCookies = () => {
  const cookiesToRemove = [
    // Google Analytics 4
    '_ga',
    '_gid',
    '_gat',
    '_gcl_au',
    '_gcl_aw',
    '_gcl_dc',
    '_gcl_gb',
    '_ga_VY1T84DLJK',

    // Microsoft Clarity
    '_clck',
    '_clsk',
    'CLID',
    'MUID',
    'ANONCHK',
    'MR',
    'MUIDB',
  ];

  cookiesToRemove.forEach((cookieName) => {
    // 也尝试移除可能的变体
    Cookies.remove(cookieName, { path: '/' });
    if (typeof window !== 'undefined') {
      Cookies.remove(cookieName, { domain: window.location.hostname });
      Cookies.remove(cookieName, { domain: '.' + window.location.hostname });
    }
  });
};

const myInsCookieConsentName = 'myInsCookieConsent';

const CookieConsentContent = () => {
  const { t } = useTranslation();

  const handleAccept = async () => {
    // 自定义逻辑，比如设置 cookies
    setConsent({
      analytics_storage: 'granted',
    });
    clarity.consent(true);
  };

  const handleDecline = () => {
    // 自定义逻辑，比如删除 cookies
    Cookies.remove(myInsCookieConsentName); // 删除 cookie
    clearAnalyticsCookies();
    setConsent({
      analytics_storage: 'denied',
    });
    clarity.consent(false);
  };

  return (
    <CookieConsent
      location="bottom"
      buttonText={t('Accept')}
      cookieName={myInsCookieConsentName}
      expires={365}
      onAccept={handleAccept}
      enableDeclineButton
      declineButtonText={t('Not Now')}
      onDecline={handleDecline}
      containerClasses={styles.cookieConsentContainer}
      contentClasses={styles.cookieConsentMessage}
      buttonWrapperClasses={styles.cookieConsentButtons}
      style={{ background: '#EAE8FF', zIndex: '9999' }}
      buttonClasses={styles.btnStyle}
      declineButtonClasses={styles.declineBtnStyle}
      buttonStyle={{
        backgroundColor: 'var(--app-primary-color)',
        color: `var(--other-text-color)`,
        fontSize: '14px',
        borderRadius: '4px',
        padding: '8px',
        margin: '15px 15px 0 15px',
      }}
      declineButtonStyle={{
        backgroundColor: '#fff',
        color: '#000',
        fontSize: '14px',
        borderRadius: '4px',
        padding: '8px',
        margin: '15px 15px 0 15px',
      }}
    >
      <div className={styles.cookieConsentMessage}>
        <span>{`${t('We use cookies to improve your experience and for marketing. Read our')} `}</span>
        <Link href="/cookie-policy">{t('Cookie Policy')}</Link>
      </div>
    </CookieConsent>
  );
};

export default CookieConsentContent;

export { myInsCookieConsentName };
